import { render, staticRenderFns } from "./ReceiptAction.vue?vue&type=template&id=09b872cc&scoped=true&"
import script from "./ReceiptAction.vue?vue&type=script&lang=js&"
export * from "./ReceiptAction.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptAction.vue?vue&type=style&index=0&id=09b872cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b872cc",
  null
  
)

export default component.exports